import { createFileRoute } from '@tanstack/react-router';

import { DictionaryCreate } from '@/module/Author/Dictionary/DictionaryCreate';

export const Route = createFileRoute('/_auth/author/_author/dictionary/_dictionary/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <DictionaryCreate />;
}
